<template>
  <div>
    <shipblu-button size="small" :textButton="$t('Export')" :iconStyle="{LeftIconName: 'DownloadIcon', LeftIconLibrary: 'feather', iconPosition: 'left'}" @click="openExportModal()"/>
    <shipblu-prompt
      class="shipment-modal"
      @close="closeExportModal"
      :active.sync="exportModal"
      :title="$t('Export')"
      :buttons-hidden="true">
      <div class="text-center mt-1">
        <div class="mb-4">
          <p class="text-darkgray text-base mb-4">{{ $t('Select orders statuses you want to export!') }}</p>
          <div class="clearfix flex justify-center">
            <div v-for="(criteria, index) in criterias" :key="index">
              <label @click="checkCriteria(criteria)" class="prompt cursor-pointer whitespace-nowrap">
                <input v-model="criteriaName" :class="criteria.checked ? 'checked' : ''" :value="criteria.value" type="radio" />
                <span class="py-2 px-4 rounded mx-1">{{ $t(criteria.name) }}</span>
              </label>
            </div>
          </div>
        </div>

        <p class="text-darkgray">{{ $t('Select your export range!') }}</p>
        <div class="mt-4 md:flex block gap-4 justify-center">
          <div class="flex justify-center">
            <datepicker :inline="true" name="from" :disabledDates="disabledDatesStart" v-model="startDate"></datepicker>
          </div>
          <div class="flex justify-center md:mt-0 mt-4">
            <datepicker :inline="true" name="to" :disabledDates="disabledDates" v-model="endDate"></datepicker>
          </div>
        </div>

        <div class="flex justify-evenly mt-3">
          <p class="text-blue-900 border-0 border-b border-solid border-[#9DADC2] p-2">{{startDate ? common.gettingDate(new Date(startDate).toISOString()) : $t('No Date')}}</p>
          <div class="flex" :style="$i18n.locale === 'ar' ? 'transform: rotate(180deg);' : ''">
            <img class="w-3" src="@/assets/images/pages/arrow.svg" alt="">
            <img class="w-3" src="@/assets/images/pages/arrow.svg" alt="">
          </div>
          <p class="text-blue-900 border-0 border-b border-solid border-[#9DADC2] p-2">{{endDate ? common.gettingDate(new Date(endDate).toISOString()) : $t('No Date')}}</p>
        </div>

        <div class="grid grid-cols-2 gap-4 mt-4">
          <shipblu-button size="small" color="secondary" :textButton="$t('Cancel')" @click="closeExportModal()"/>
          <shipblu-button size="small" :textButton="$t('Export')" @click="sendExport()"  :disabled="criteriaName !== '' && startDate && endDate ? false : true"/>
        </div>
      </div>
    </shipblu-prompt>
  </div>
</template>
  
<script>
import Datepicker from 'vuejs-datepicker'
import { sendFulfillmentRequest } from '../../../../http/axios/requestHelper'
import i18nData from '../../../../i18n/i18nData'
import ShipbluPrompt from '../../../../layouts/components/ShipBluPrompt.vue'
import common  from '@/assets/utils/common'

export default {
  data () {
    return {
      common,
      criterias: [
        {
          name: 'Created',
          value: 'created',
          checked: false
        },
        {
          name: 'In Progress',
          value: 'in progress',
          checked: false
        },
        {
          name: 'Shipped',
          value: 'shipped',
          checked: false
        }
      ],
      exportModal: false,
      criteriaName: '',
      startDate: '',
      endDate: '',
      disabledDates: {
        to: new Date(), 
        from: new Date()
      },
      disabledDatesStart: {
        from: new Date()
      }
    }
  },
  watch: {
    'startDate' () {
      const date = new Date(this.startDate)
      this.endDate = this.startDate ? new Date(this.startDate) : ''
      const endDate = new Date(this.startDate)
      const maxDate = new Date(endDate.setDate(date.getDate() + 30))
      const today = new Date()
      this.disabledDates = {
        to: date,
        from: maxDate > today ? today : maxDate
      }
    }
  },
  methods: {
    checkCriteria (criteria) {
      this.criterias.forEach(item => {
        if (item.name === criteria.name) {
          item.checked = true
        } else {
          item.checked = false
        }
      })
    },
    sendExport () {
      const sendData = {
        status: this.criteriaName,
        from_date: this.startDate ? new Date(this.startDate).toISOString().split('T')[0] : '',
        to_date: this.endDate ? new Date(this.endDate).toISOString().split('T')[0] : ''
      }
      sendFulfillmentRequest(false, false, this, 'api/v1/fc/orders/outbound/export/', 'post', sendData, true,
        (response) => {
          this.$vs.notify({
            color: 'success',
            title: i18nData[this.$i18n.locale]['Success'],
            text: response.data.message,
            position: 'top-center'
          })
          this.closeExportModal()
        }
      )
    },
    closeExportModal () {
      this.exportModal = false
      this.criteriaName = ''
      this.startDate = ''
      this.endDate = ''
      this.disabledDates = {
        from: new Date()
      }
      this.criterias.forEach(item => {
        item.checked = false
      })
    },
    openExportModal () {
      this.exportModal = true
    }
  },
  components: {
    Datepicker,
    ShipbluPrompt
  }
}
</script>